<template>
  <router-link :to="to" class="button" :class="[typeClass, sizeClass]" :disabled="disabled" v-if="to">
    <slot></slot>
  </router-link>

  <button @click.prevent="onClick" class="button" :class="[typeClass, sizeClass, isLoading]" :disabled="disabled" v-else>
    <slot></slot>
  </button>
</template>

<script>
const types = ['primary', 'secondary', 'nursery-pre-school', 'pre-kindergarten', 'kindergarten', 'resources']
const sizes = ['small', 'medium', 'large']

export default {
  name: 'Button',

  props: {
    to: {
      type: Object,
      required: false
    },
    type: {
      type: String,
      default: 'primary',
      validator: value => types.includes(value)
    },
    size: {
      type: String,
      default: 'small',
      validator: value => sizes.includes(value)
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    isLoading () { return this.loading ? 'is-loading' : '' },
    typeClass () { return `button-${this.type}` },
    sizeClass () { return `button-${this.size}` }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/Button.vue